import React from 'react';
import Link from "../base/Link";
import API from "../base/API";
import Auth from "../auth/Auth";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from '../base/Translation';

export default class TranslationList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_translations: "/translation/fetch/all?limit_from=:from&limit_max=:to",
			delete_translation: "/translation/delete/:translation"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			translations: [],
			tableData: [],
			tableColumns: [
				{ name: "language", display: translate("Jazyk"), sort: true, width: 7 },
				{ name: "original", display: translate("Originál"), sort: true, width: 44 },
				{ name: "translated", display: translate("Preklad"), sort: true, width: 44 },
				{ name: "options", display: " ", width: 5 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (t) {

			t.original = <Link to={"/translations/edit/" + t.id}>{t.original}</Link>;
			t.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.deleteTranslation.bind({ translation: t.id, currentComponent: this })} permission="TranslationDelete" />
				</div>
			);

			return t;
		}.bind(this));
	}

	fetchData() {
		this.api.request({
			cache: true,
			route: "get_translations",
			params: { from: this.state.limit_from, to: this.state.limit_to },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ translations: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	deleteTranslation(evt) {
		this.currentComponent.api.request({
			route: "delete_translation",
			params: { translation: this.translation },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	buildTableLoading() {
		return (
			<tr>
				<td colSpan="5">{translate("Načítavam...")}</td>
			</tr>
		)
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="original" title={translate("Preklady")} right={() => {
				return (
					<Link to="/translations/add/new" permission="TranslationNew" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/translation/TranslationList.js